import React, { useEffect, useState, useCallback, useMemo, useRef } from "react"
import { AgGridReact } from "ag-grid-react"
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import Modal from "react-modal";
import downloadIcon from '../../assets/downloadIcon.png'
import ModalContent from '../../common/Modal/ModalContent';
import close_modal from '../../assets/ic_close_wh.svg'
import ic_filter from '../../assets/ic_filter.svg'
import { Button } from "../../common/Button/Button";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import { Info } from "react-feather";

const SourcesBasedOnEntryPointTable = (props) => {

  // const [MergedPartnerResourceModal, setMergedPartnerResourceModal] = useState(false)
  const [topEntryPointModal, setTopEntryPointModal] = useState(false)

  const gridRef = useRef()
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

  const data = props.topSourcesBasedOnEntryPoint

  const [rowData, setRowData] = useState([]);

   const [partnerNameOptions, setPartnerNamesOptions] = useState([])

  // my functions for dreamBig
  useEffect(()=>{
    setRowData(data);

    let options = data.map((obj) => {
      const {Source_Id} = obj;

      return Source_Id;
    })
    // setPartnerNamesOptions(options)

    let uniqueOptions = options.reduce((acc, curr) => {
      if(!acc.includes(curr)){
        acc.push(curr)
      }
      return acc;
    }, [])

    setPartnerNamesOptions(uniqueOptions)

  }, [data])


  //for modal open
  const openTopEntryPointModalisTrue = () => {
    setTopEntryPointModal(true)
  }

  const openTopEntryPointModalisFalse = () => {
    setTopEntryPointModal(false)
  }

  // for selection option
  const handleTopEntryPointSelect = (selected) => {
    props.setSelectedOptionsTopEntryPoint(selected)
    console.log(">>>>select", props.selectedOptionsTopResources)
  }

  // handle search click
  const handleTopEntryPointFilterSearchClick = () => {
    if(props.selectedOptionsTopEntryPoint.length > 0){
      let selectedOptionsVals = props.selectedOptionsTopEntryPoint.map((obj) => {
        const {value} = obj
        return value;
      })

      let copyOriginalData = [...props.topSourcesBasedOnEntryPoint]

      console.log(copyOriginalData, ">>>>>copyOriginalData");
      
      let filteredRowData = copyOriginalData.filter((obj) => {
        if(selectedOptionsVals.includes(obj.Source_Id)){
          return obj
        }
      })

      console.log(filteredRowData, ">>>>filteredRowData topSourcesBasedOnEntryPoint");
      setRowData(filteredRowData);
    }else if(props.selectedOptionsTopEntryPoint.length <= 0){
      setRowData(props.topSourcesBasedOnEntryPoint)
    }

    setTopEntryPointModal(false);
  }

  const handleClearClickTopEntryPoint = () => {
    // dreamBig
    props.setSelectedOptionsTopEntryPoint([])
  }

  /////////////////////////////////////////////

  const footerRow = {
    resourcedisplay_name: "Total",
    FTU_Count: "Total : " + (
      rowData ? rowData.reduce((total, row) => total + row.FTU_Count, 0) : 0
    ),
    EU_Count: "Total : " + (
      rowData ? rowData.reduce((total, row) => total + row.EU_Count, 0) : 0
    ),
  };

  const CustomCellRenderer = (props) => {
    let resourceName = props.value;
    if (resourceName === null) {
      resourceName = "Not Provided";
    }
    if (resourceName === "Total") {
      return <div style={{ textAlign: "right", display: "none" }}>{resourceName}</div>;
    } else {
      return <div>{resourceName}</div>;
    }
  };

  const [columnDefs, setColumnDefs] = useState([
    {
      field: "Source_Id",
      headerName: "Partner Name",
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", width: '50px', alignItems: "center" }}>
            <div style={{ marginRight: "110px" }}>{params.displayName}</div>
            <img
                alt=""
                src={ic_filter}
                height={"25px"}
                width={"25px"}
                className="conv-mr10"
                onClick={() => openTopEntryPointModalisTrue()}
            />
          </div>
        );
      },
      width: 380,
      cellStyle: { 'white-space': 'normal' },
      autoHeight: true,
      cellRendererFramework: CustomCellRenderer,
    },
    {
      field: "FTU_Count",
      headerName: "First Time Count",
      // width: 180,
      flex: 1,
      sortable: true,
      pinnedBottomRowCellRenderer: "agGroupCellRenderer",
      cellStyle: { textAlign: "right" },
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center" }}>
            <div>{params.displayName}</div>
          </div>
        );
      },
    },
    {
      field: "EU_Count",
      headerName: "Engaged Count",
      // width: 180,
      flex: 1,
      sortable: true,
      pinnedBottomRowCellRenderer: "agGroupCellRenderer",
      cellStyle: { textAlign: "right" },
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center" }}>
            <div>{params.displayName}</div>
          </div>
        );
      },
    },
  ]);

  const gridOptions = useMemo(() => ({
    suppressScrollOnNewData: true,
  }), []);


  const overlayNoRowsTemplate = rowData.length === 1 && rowData[0].sEntryPoint === "No Data Available"
  ? '<span class="ag-overlay-no-rows-center">No data available</span>'
  : '<span class="ag-overlay-no-rows-center">loading...</span>';
  
  console.log(props.selectedOptionsTopEntryPoint, ">>>>>>props.selectedOptionsTopEntryPoint");
  return (
    <div>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        // justifyContent: 'center',
        margin: 10
      }}>
        <h3 className="spled-colored-label" style={{
          fontSize: "20px",
          textAlign: 'center',
          marginRight: 10
        }}>7. First time and Engaged Users based on Top Sources</h3>
        <span style={{ cursor: "pointer" }} title="Display of First time users and engaged users based on top Sources">
          <Info style={{ width: "15px", marginRight: "10px", marginBottom:"5px" }} />
        </span>
      </div>
      <div style={{
        height: "50vh",
      }}>
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <div style={gridStyle} className="ag-theme-material">
            <AgGridReact ref={gridRef}
              rowData={rowData}
              columnDefs={columnDefs}
              pinnedBottomRowData={[footerRow]}
              gridOptions={gridOptions}
              overlayNoRowsTemplate={
                '<span class="ag-overlay-loading-center">No data available...</span>'
              }
              rowClassRules={{
                'total-row': 'data.resourcedisplay_name === "Total"'
              }}
            >
            </AgGridReact>
          </div>
        </div>

        <Modal isOpen={topEntryPointModal}>
          <ModalContent className="EngagedDashboard-filter-modal">
            <div className="modal-header">
              <span className="modal-title">Filter</span>
              <img
                alt="close"
                id="Close"
                src={close_modal}
                className="close modal-close"
                onClick={openTopEntryPointModalisFalse}
              />
            </div>

            <div className="modal-body">
              <br />
              <div className="row">
                <div className="col-12 spled-container">
                  <div className="width-100">
                    <ReactMultiSelectCheckboxes
                      options={partnerNameOptions.map((entrypoint) => ({
                        label: entrypoint ? entrypoint : "No Partner Name (blank)",
                        value: entrypoint ? entrypoint : "",
                      }))}
                      placeholderButtonLabel="Select Partner"
                      value={props.selectedOptionsTopEntryPoint}
                      onChange={handleTopEntryPointSelect}
                    />
                  </div>
                </div>
              </div>
              <br />
              <div className='row d-flex justify-content-center align-items-center'>
                <div className="offset-1 col-5">
                  <Button className="esp-inline-button" 
                  onClick={handleTopEntryPointFilterSearchClick}
                  >Search</Button>
                </div>
                <div className="col-5">
                  <Button className="esp-inline-button"
                  onClick={handleClearClickTopEntryPoint}
                  >Clear</Button>
                </div>
              </div>

            </div>
          </ModalContent>
        </Modal>
      </div>
    </div>
  )
}

export default SourcesBasedOnEntryPointTable
